import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-[#F2D70A] shadow-2xl z-50 p-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-start space-x-3 flex-1">
          <i className="ri-cookie-line text-3xl text-[#F2D70A] flex-shrink-0"></i>
          <div>
            <h3 className="font-semibold text-[#544E13] mb-1">Uso de Cookies</h3>
            <p className="text-sm text-gray-600">
              Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación. Si continúa navegando, consideramos que acepta su uso.
            </p>
          </div>
        </div>
        <div className="flex space-x-3 flex-shrink-0">
          <button
            onClick={rejectCookies}
            className="px-6 py-2.5 border-2 border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Rechazar
          </button>
          <button
            onClick={acceptCookies}
            className="px-6 py-2.5 bg-[#F2D70A] text-[#544E13] rounded-lg font-semibold hover:bg-[#544E13] hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}